<template>

  <v-card variant="tonal">

    <v-card-title>

      <div class="d-flex align-center w-100 text-body-1 ga-3 mb-4">
        <v-chip :text="chip" size="small" :color="chipColor" />
        <div>{{ title }}</div>
        <div class="text-end flex-grow-1 text-grey">{{ help }}</div>
      </div>

    </v-card-title>

    <v-card-text>

      <template v-if="!model.length">
        <v-alert class="text-center mb-5">
          {{ emptyMessage }}
        </v-alert>
      </template>


      <template v-else>
        <flex-discount-item
          v-for="(row, i) in model"
          :key="i"
          v-model="model[i] as unknown as FlexDiscountRow"
          :days-prefix="daysPrefix"
          :days-suffix="daysSuffix"
          @delete-clicked="tierDeleted(i)"
          :other-row-days="model.filter(r => r !== row).filter(r => !!r.days).map(r => r.days!)"
        />
      </template>

      <v-btn prepend-icon="$create" @click="addTier()" class="w-100" variant="outlined" :disabled="!canAddTier">
        {{ $t('actions.add_tier') }}
      </v-btn>

    </v-card-text>

  </v-card>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import FlexDiscountItem from './FlexDiscountItem.vue'

import { type FlexDiscountRow, spotheroFlexDiscountDurations } from './types'

interface Props {
  title: string
  chip: string
  chipColor: string
  help: string
  emptyMessage: string
  daysPrefix?: string
  daysSuffix?: string
}

withDefaults(defineProps<Props>(), {
  chipColor: 'secondary',
})

const emit = defineEmits(['discountDeleted'])

/**
 *
 */

const model = defineModel<FlexDiscountRow[]>({default: () => []})

/**
 *
 */

const canAddTier = computed<boolean>(() => {
  return model.value.length < spotheroFlexDiscountDurations.length
})

function addTier() {

  const longestTier = model.value.filter(row => !!row.days).sort((row1, row2) => row1.days! - row2.days!).at(-1)
  const longestTiersDays = longestTier ? longestTier.days! : 0
  const nextDuration = spotheroFlexDiscountDurations.find(d => d.value > longestTiersDays)

  model.value.push({
    id: null,
    days: nextDuration ? nextDuration.value : null,
    percentage: 0,
  })

}

function tierDeleted(rowIndex: number) {
  const row = model.value[rowIndex]
  if (row.id) {
    emit('discountDeleted', row.id)
  }
  model.value.splice(rowIndex, 1)
}

</script>
